var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsNewPermalink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 12,
    viewBox: "0 0 24 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.28 6C2.28 3.948 3.948 2.28 6 2.28H10.8V0H6C2.688 0 0 2.688 0 6C0 9.312 2.688 12 6 12H10.8V9.72H6C3.948 9.72 2.28 8.052 2.28 6ZM7.2 7.2H16.8V4.8H7.2V7.2ZM18 0H13.2V2.28H18C20.052 2.28 21.72 3.948 21.72 6C21.72 8.052 20.052 9.72 18 9.72H13.2V12H18C21.312 12 24 9.312 24 6C24 2.688 21.312 0 18 0Z",
    fill: "#2E3944"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsNewPermalink);
export default __webpack_public_path__ + "static/media/icons_new_permalink.f5912314.svg";
export { ForwardRef as ReactComponent };